@let m = meter();
<article class="tf-billing-meter" [class.tf-billing-meter--danger]="m.capTone === 'danger'">
  <header class="tf-billing-meter__head">
    <div class="tf-billing-meter__label-wrap">
      <h4 class="tf-billing-meter__label">{{ m.labelKey | translate }}</h4>
      @if (isFullyUnmetered()) {
        <span class="tf-billing-meter__unlimited-badge">
          {{ 'SETTINGS_BILLING.PLAN.METERS.UNLIMITED_BADGE' | translate }}
        </span>
      }
    </div>
    <p class="tf-billing-meter__value" [class.tf-billing-meter__value--failed]="m.loadFailed">
      @if (m.loadFailed) {
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      }
      {{ m.valueLabel }}
    </p>
  </header>

  <div
    class="tf-billing-meter__bar"
    [class.tf-billing-meter__bar--unlimited]="isFullyUnmetered()"
    [class.tf-billing-meter__bar--failed]="m.loadFailed"
    aria-hidden="true">
    @if (!isFullyUnmetered() && !m.loadFailed) {
      @if (m.includedPercent > 0) {
        <span
          class="tf-billing-meter__segment tf-billing-meter__segment--included"
          [style.width.%]="m.includedPercent"></span>
      }
      @if (m.overagePercent > 0) {
        <span
          class="tf-billing-meter__segment tf-billing-meter__segment--{{ m.capTone }}"
          [style.width.%]="m.overagePercent"></span>
      } @else if (m.includedPercent === 0 && m.percent > 0) {
        <span
          class="tf-billing-meter__segment tf-billing-meter__segment--{{ m.capTone }}"
          [style.width.%]="m.percent"></span>
      }
      @if (m.overCapPercent > 0) {
        <span
          class="tf-billing-meter__segment tf-billing-meter__segment--danger"
          [style.width.%]="m.overCapPercent"></span>
      }
      @if (hasIncludedTick()) {
        <span
          class="tf-billing-meter__tick"
          [style.inset-inline-start.%]="m.includedPercent"
          aria-hidden="true"></span>
      }
    }
  </div>

  @if (!m.loadFailed) {
    <footer class="tf-billing-meter__foot">
      <div class="tf-billing-meter__pricing">
        @switch (m.pricing.kind) {
          @case ('simple') {
            <span>{{ m.pricing.rateLabel }}</span>
          }
          @case ('freePlusOne') {
            <span>
              {{
                'SETTINGS_BILLING.PLAN.METERS.PRICING_FREE_PLUS_ONE'
                  | translate: { free: m.pricing.freeLabel, rate: m.pricing.rateLabel }
              }}
            </span>
          }
          @case ('freePlusMany') {
            <span class="tf-billing-meter__pricing-text">
              {{
                'SETTINGS_BILLING.PLAN.METERS.PRICING_FREE_PLUS_MANY_PREFIX'
                  | translate: { free: m.pricing.freeLabel }
              }}
            </span>
            <button type="button" class="tf-billing-meter__pricing-link" (click)="onShowPricing()">
              {{ 'SETTINGS_BILLING.PLAN.METERS.PRICING_SHOW_TIERS' | translate }}
            </button>
          }
          @case ('many') {
            <button type="button" class="tf-billing-meter__pricing-link" (click)="onShowPricing()">
              {{ 'SETTINGS_BILLING.PLAN.METERS.PRICING_SHOW_TIERS' | translate }}
            </button>
          }
        }
      </div>
      @if (m.overageCostLabel) {
        <div class="tf-billing-meter__period-cost">
          {{
            'SETTINGS_BILLING.PLAN.METERS.APPROX_PERIOD_COST'
              | translate: { amount: m.overageCostLabel }
          }}
        </div>
      }
    </footer>
  }
</article>
